import { TailwindColorOrString } from '@repo/tailwind-config/tailwind.vars'
import React from 'react'

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './tooltip'
import Typography from './typography'

type CapsuleItem = {
  value: number
  color: TailwindColorOrString
  background: TailwindColorOrString
  tooltip?: string
}

type Props = {
  hideTotal?: boolean
  items: CapsuleItem[]
}

const TOOLTIP_DELAY_DURATION = 300 // in ms

const CapsuleInformation: React.FC<Props> = ({ hideTotal, items }) => {
  const totalValue = items.reduce((acc, item) => acc + item.value, 0)

  if (totalValue === 0) return null
  return (
    <div className="flex items-center gap-1">
      <div className="bg-white shadow p-1 rounded-full drop-shadow-2xl">
        <div className="flex rounded-full overflow-hidden w-48">
          {items.map((item, index) => {
            const percentage = (item.value / totalValue) * 100
            const style: React.CSSProperties = {
              color: item.color,
              backgroundColor: item.background,
              width: `${percentage}%`,
              minWidth: '1rem',
              display: percentage === 0 ? 'none' : 'block'
            }

            const capsuleContent = (
              <div style={style} className="flex items-center justify-center p-1">
                <Typography variant="small-semibold" className="text-center">
                  {item.value}
                </Typography>
              </div>
            )

            if (!item.tooltip) return <React.Fragment key={index}>{capsuleContent}</React.Fragment>

            return (
              <TooltipProvider delayDuration={TOOLTIP_DELAY_DURATION} key={index}>
                <Tooltip>
                  <TooltipTrigger style={style}>{capsuleContent}</TooltipTrigger>
                  <TooltipContent className="h-full max-h-48 overflow-y-auto text-white p-3 py-2 bg-grey rounded-sm">
                    <Typography variant={'label-medium'}>{item.tooltip}</Typography>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            )
          })}
        </div>
      </div>
      {!hideTotal && (
        <Typography variant="label-semibold" className="text-grey">
          ({totalValue})
        </Typography>
      )}
    </div>
  )
}

export default CapsuleInformation
